<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="content-title">
                    <h2>No access yet</h2>
                </div>
                <hr>
                <div class="panel">
                    <p>Your account is signed in, but no role gives it access to any page.</p>
                    <p>Ask an admin who manages roles to assign you one, then sign in again or reload this page.</p>
                </div>
            </div>
        </div>
    </div>
</div>
